import { lazy } from 'react';

import Main from 'src/layouts/Main/Layout';

const Contact = lazy(() => (import("src/pages/contact/Contact")));
const NotFound = lazy(() => import("src/pages/notFound/NotFound"));


const routes = [
    {
        path: '/',
        element: Main,
        routes: [
            {
                path: '',
                element: Contact
            },
            {
                path: 'contact',
                element: Contact
            },
            { path: '*', element: NotFound }
        ]
    }
];

export default routes;
